import React from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";

function ArtService() {

    const { t } = useTranslation();

    return (
        <main className="artService">
            <div className="mediaArt">{infoSection(t("artService.title1"), t("artService.subtitle1"), t("artService.rightcontent1"))}</div>

            <div className="wallMuseum">
                <div className="info">{infoSection(t("artService.title2"), t("artService.subtitle2"),  t("artService.rightcontent2"), false)}</div>
            </div>

            {/* <div className="viewMore">{infoSection("Art Service", "View More", "더보기")}</div> */}
        </main>
    );
}

export default ArtService;

const infoSection = (sub: string, title: string, extend: string, darkColor = true) => (
    <div
        style={{
            color: darkColor ? "#111" : "#fff",
        }}
        className="infoSection"
    >
        <div className="subtitle">{sub}</div>
        <div className="title">
            <h2
                style={{
                    color: darkColor ? "#111" : "#fff",
                }}
            >
                {title}
            </h2>
            <div className="extend">{extend}</div>
        </div>
    </div>
);
